<div class="dynamic-select">
    <mat-form-field appearance="outline" *ngIf="editingMode">
      <mat-label>{{inputLabel}}</mat-label>
      <mat-select (selectionChange)="updateSelection($event.value)">
        <mat-option *ngFor="let fks of elements" [value]="fks" >
          {{fks[displayedValue1]}} {{fks[displayedValue2]}}
        </mat-option>
      </mat-select>
    </mat-form-field>
    
    <mat-label *ngIf="inputValue && !editingMode" style="font-size: 10px;">{{inputLabel}}</mat-label>
    <mat-chip-list *ngIf="!editingMode" class="chip-edit" >
      <mat-chip *ngIf="inputValue" class="chip-edit" color="primary" selected (click)="editingMode = !editingMode"> 
        {{inputValue}}
      </mat-chip>
      <mat-chip (click)="editingMode = !editingMode" *ngIf="!inputValue"> 
        {{inputLabel}}: 
      </mat-chip>
    </mat-chip-list>
    
    <i class="fas fa-solid fa-angle-up icon" *ngIf="editingMode" (click)="editingMode = !editingMode"></i>
</div>